// extracted by mini-css-extract-plugin
export var btn_wrapper = "index-module--btn_wrapper--8c07f";
export var education_plan_btn = "index-module--education_plan_btn--b25ee";